/**
 * Device Operations End Time Cell - Frontend
 * @description Cell component for displaying operation end time
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { MapPin } from 'lucide-react';
import { DashboardOperation } from '@/types/dashboard.types';

export const DeviceOperationsCentroidLocationCell: React.FC<{
  info: CellContext<DashboardOperation, string>;
}> = ({ info }) => {
  const row = info.row.original;
  const coordinatesFormatted =
    row.centroidLocation?.latitude.toFixed(6) + ',' + row.centroidLocation?.longitude.toFixed(6);

  const handleMapClick = () => {
    if (row.centroidLocation?.latitude && row.centroidLocation?.longitude) {
      const googleMapsUrl = `https://www.google.com/maps?q=${row.centroidLocation.latitude},${row.centroidLocation.longitude}`;
      window.open(googleMapsUrl, '_blank');
    }
  };

  return (
    <div className="text-sm text-center">
      <div
        className="flex items-center gap-1 text-gray-900 cursor-pointer hover:text-orange-500 transition-colors duration-200"
        onClick={handleMapClick}
        title="Click para abrir en Google Maps"
      >
        <MapPin className="h-3 w-3 hover:text-orange-500 transition-colors duration-200" />
        {coordinatesFormatted}
      </div>
    </div>
  );
};
